import { createClient } from '@supabase/supabase-js'
import type { Profile } from '../types/database.tables'
import type { Database } from '../types/database.types'

export const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'http://127.0.0.1:54321'
const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0'

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
})

export type UserRoleType = 'coach' | 'athlete'

export type AuthUser = {
  id: string
  email: string
  profile?: Profile
}
